import { useQuery } from "@tanstack/react-query";

import { MediaData } from "../../models/MediaData";
import DataSvc from "../../services/dataSvc";

export type UseFirstMediaOptions = {
  locationId?: string;
  category?: string;
};

/**
 * Query for fetching and returning the first image that matches the given criteria
 * Useful for displaying the cover/profile photo (a location can only have one of each, but the API tends to hold onto old ones as well)
 */
export const useFirstMedia = (options: UseFirstMediaOptions) => {
  const { locationId, category } = options;

  const queryFn = async () => {
    if (!locationId) return null;
    const results = await DataSvc.getMedia({
      order: "desc",
      sort: "created_at",
      location_id: [locationId],
      category,
      limit: 1,
    });
    return (results as MediaData[])[0] ?? null;
  };

  const query = useQuery<MediaData | null>(
    ["media", locationId, category, "first"],
    queryFn,
    { enabled: !!locationId }
  );

  return query;
};
